/* eslint-disable max-lines */

// Интерфейсы выпилятся в api-models https://cianru.atlassian.net/browse/CD-33779

import { IReviewStat } from '../reviewStat';
import { IBrokerData } from '../broker';

/**
 * TODO привести типы к схеме ответа
 */

export interface IImageInfo {
  listingJkMini: string;
  id: number;
  thumbnail2Url: string;
  isDefault: boolean;
  thumbnailUrl?: string;
  fullUrl?: string;
  miniUrl?: string;
}

export interface ISecurityInfo {
  id: number;
  name: string;
}

export interface IAddressLine {
  geoType: string;
  qs: string;
  title: string;
  fullUrl?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IFtalsTypes {}

export interface IProjectDocumentations {
  isLoadedManually: boolean;
  url: string;
  name: string;
}

export interface IGeoAddressDetails {
  id: number;
  shortName: string;
  locationTypeId?: number;
  name: string;
  fullName: string;
  isFormingAddress: boolean;
  type: string;
}

export interface IDistrictInfo {
  id: number;
  name: string;
  parentId?: null | number;
  type?: null | string;
  locationId: number;
}

export interface IUndergroundInfo {
  id: number;
  calcTimeCarAdmin: number;
  cianId?: null | number;
  calcTimeCar: number;
  transportId: number;
  time: number;
  name: string;
  calcTimeWalk: number;
  calcTimeWalkAdmin: number;
  lineId: number;
  lineColor: string;
  url?: string;
  fullUrl?: string;
  transportType?: string;
  qs?: string;
}

export interface IMaterials {
  id?: null | number;
  name?: null | string;
}

export interface IGeo {
  address: {
    details: IGeoAddressDetails[];
    countryId: number;
    streetShortName?: string;
    streetId?: number;
    street?: {
      id: number;
      fullName: string;
      shortName: string;
      name: string;
      isFormingAddress: boolean;
      type: string; //TODO oneOf
    };
    region: {
      id: number;
      shortName: string;
      locationTypeId: number;
      name: string;
      fullName: string;
      isFormingAddress: boolean;
      type: string;
    };
    house?: {
      fullName: string;
      isFormingAddress: boolean;
      type: string;
      id: number;
      name: string;
      shortName: string;
    };
    houseId?: number;
  };
  districtInfo: IDistrictInfo[];
  coordinates: {
    lng: number;
    lat: number;
  };
  undergroundInfo: IUndergroundInfo[];
  roadInfo: {
    id: number;
    distance: string;
    name: string;
  }[];
  timezone: number;
}

export interface IHouses {
  id: number;
  material: IMaterials;
  projectDocumentations: IProjectDocumentations[];
  turn: string;
  cargoLiftsCount?: null | number;
  parkingTypes: {}[];
  fullAddress: string;
  saleType?: null | string | number;
  name: string;
  floor: {
    to?: null | number;
    from?: null | number;
  };
  geo: IGeo;
  finishYear?: number;
  finishQuarter?: number;
  reliableStatus: string;
  offersSubscribeUrl?: string;
  passengerLiftsCount?: null | number;
  buildingStatus: number;
  properties: {}[];
  ceilingHeight?: null | number;
  isFinished?: boolean;
  finishDate?:
    | {
        quarter: number;
        year: number;
      }
    | {};
  isFz_214?: boolean;
  isApartment?: boolean;
  isDjsk?: boolean;
}

export interface IWorkTimeInfo {
  callFrom: string;
  callTo: string;
  isAvailable?: boolean;
  timezoneText?: string;
  userId?: number;
}

export interface IBuildingStatus {
  count: number;
  statusId: number;
  housesCount: number;
  url: string;
}

export interface IBuilder {
  workTimeInfo?: null | IWorkTimeInfo;
  id: number;
  logoUrl: string;
  name: string;
  url: string;
  realtyUserId?: number | null;
  creationDate?: string;
  phone: string | null;
  sinceYear?: number;
  dataLayer?: {
    id: number;
    dealType: string;
    objectType: string;
    name: string;
    category: string;
    published: boolean;
    quantity: number;
    nv: boolean;
    photosCount: number;
    brand: string;
  };
  isMortgageTest?: boolean;
  buildingStatus?: IBuildingStatus[];
  newbuildingDynamicCalltracking: {
    siteBlockId: number | null;
  };
}

export interface IRoomCounter {
  offersCount: number;
  roomCount: string;
  url: string;
}

export interface IBuilderStats {
  minPropPrice: number;
  maxPropPrice: number;
  countsByRoom: IRoomCounter[];
  propsCount: number;
  mapFullUrl: string;
}

export interface IFirstMaterial {
  id: number;
  name: string;
}

export type TRoomType = 'studio' | 'room' | 'oneRoom' | 'twoRoom' | 'threeRoom' | 'fourRoom';

export interface IRoom {
  maxPriceSquare: string;
  room: TRoomType;
  minPrice?: string;
  offersCount: number;
  hasDecoration: boolean;
  maxPrice?: string;
  minPriceSquare: string;
  minTotalArea: number;
}

export interface IFromDevelopersRoom {
  countDisplay: string;
  minTotalArea: string;
  minPrice2: string;
  maxPrice2: string;
  price2Range: string;
  offersCount: number;
  offersUrl: string;
  roomCount?: string;
}

export interface ISeller {
  workTimeInfo?: IWorkTimeInfo | null;
  userTrustLevel: string;
  name: string;
  avatarUrl: string;
  realtyUserId: number;
  phone: string;
  isBuilder: boolean;
  isLeadFactory?: boolean;
  dataLayer?: {
    id: number;
    photosCount: number;
    dealType?: string;
    objectType?: string;
    name?: string;
    category?: string;
    published?: boolean;
    quantity?: number;
    nv?: boolean;
    brand?: string;
  };
  newbuildingDynamicCalltracking: {
    siteBlockId: number | null;
  };
}

export interface IGaLabels {
  short: string;
  full: string; // customPageUrl
}

export interface INewbuildingFeatures {
  videosCount: number | null;
  hasMVK: boolean;
  reviewsCount: number | null;
  hasProgressOfConstructions: boolean;
}

export interface INewbuildingFeatureV2 {
  link?: string | null;
  text: string;
  type: EFeatureType;
}

export enum EFeatureType {
  /** Наличие 3D тура **/
  Has3dTour = 'has3dTour',
  /** Наличие Записи на просмотр **/
  HasFlatTourBooking = 'hasFlatTourBooking',
  /** Наличие МВК **/
  HasMvk = 'hasMvk',
  /** Наличие хода строительства **/
  HasProgressOfConstructions = 'hasProgressOfConstructions',
  /** Наличие видео **/
  HasVideo = 'hasVideo',
  /** Наличие отзывов **/
  Reviews = 'reviews',
}

export interface INewbuildingGeoDistance {
  name: string;
  travelTime: number;
  type: string;
  transportType: string;
}

export interface INewbuildingPromo {
  newbuildingLabel: string;
  promoType: EPromoType;
  specProject: boolean;
}

export enum EPromoType {
  Bank = 'bank',
  Bonus = 'bonus',
  Discount = 'discount',
  Mortgage = 'mortgage',
}

export interface INewbuilding {
  id: number;
  infrastructure: {}[];
  isFz_214: boolean;
  completionYear?: string;
  addressLine: IAddressLine[];
  creationDate: string;
  security?: null | ISecurityInfo[];
  specProjectPriority?: {} | null;
  fullUrl: string;
  fullAddress?: null | string;
  firstMaterial?: IFirstMaterial | null;
  fromAgentsCountsDisplay: string;
  fromDeveloperPropsCount: number;
  fromDevelopersRooms: IFromDevelopersRoom[];
  flatTypes?: null | IFtalsTypes[];
  floor: {};
  fromDeveloper: boolean;
  webSiteUrl?: null | string;
  propsCount?: null | number;
  slugName?: null | string;
  url: string;
  priceForObject?: null | {
    to?: null | number;
    from?: null | number;
  };
  priceForMeter: {};
  secondaryPropsCount: number;
  showReliableBuilderFlag: boolean;
  specProjectMinPrice: number;
  squareFull: {};
  showReliableFlag: boolean;
  trustRank: number;
  priceto?: null | null | number;
  pricefrom?: null | number;
  promos?: null | {}[];
  promoInfoList: INewbuildingPromo[];
  isFavorite?: null | boolean;
  hasSpecProjectPromos: boolean;
  housesBuildingStatus?: null | number[];
  penthouse?: null | boolean;
  primaryPropsCount?: null | number;
  rooms?: IRoom[]; // TODO возможно по факту будет одно из: rooms, fromDevelopersRooms, flatTypeRooms
  published: boolean;
  houses?: null | IHouses[];
  isSalesLeader: boolean;
  salesStartLabel?: string | null;
  isUpcomingSale?: boolean | null;
  sellers?: null | ISeller[];
  mergedNewbuildingIds?: null | number[];
  materials?: null | IMaterials | IMaterials[];
  newObjectClassInfo: {};
  additionalDescriptions?: null | {
    priceAndQuality?: null | string;
    architecture?: null | string;
    developerReliability?: null | string;
    infrastructure?: null | string;
    shortDescription?: null | string;
  };
  cardViewMode: string;
  publishDate?: null | string;
  autocompleteName?: null | string;
  isPikPromo?: null | boolean;
  parking?:
    | null
    | {
        type: string;
        lots?: null | string | number;
        levels?: null | string;
      }[];
  townNameInfo?: null | {
    shortnameGenitive: string;
    fullname: string;
    fullnamePrepositional: string;
    shortnamePrepositional: string;
    fullnameGenitive: string;
    shortname: string;
    displayname: string;
  };
  images?: IImageInfo[] | null;
  promoLabel?: null | string;
  name: string;
  typeName?: null | string;
  regionId: number;
  builders: IBuilder[];
  _periods: {}[];
  contracts: {}[];
  searchName: string;
  propsList: {}[];
  fromAgentsPropsCount: number;
  description: string;
  specialPromoOrder?: null | number;
  isDjsk: boolean;
  booking: {};
  videoUrls: {}[];
  polygon?: null;
  flatTypesCount: 0;
  banks: {}[];
  viewMode: string;
  editDate: string;
  offersSubscribeUrl?: string;
  fromDeveloperPropsLink?: string;
  fromAgentsPropsLink?: string;
  specialPromo?: string;
  buildingStatusInfo: {};
  hasLayoutImageOffers: boolean;
  progressOfConstructions: {}[];
  gaLabels: IGaLabels;
  specialStatusDisplay: string;
  apartment: boolean;
  anyIsApartment: boolean;
  undergroundInfo?: IUndergroundInfo;
  displayName?: string | null;
  newbuildingFeatures?: INewbuildingFeatures;
  newbuildingFeaturesV2?: INewbuildingFeatureV2[] | null;
  seoGeoDistance?: INewbuildingGeoDistance | null;
  isFichering?: boolean;
  reliableStatus?: string;
  priceFrom?: number;
  priceTo?: number;
  alterName?: string;
  addressInfo?: string;
  showJkReliableFlag?: boolean;
  isProblem?: boolean;
  isDealRequestSubstitutionPhone: boolean;
  hasTour?: boolean;
  reviewStat?: IReviewStat;
  newbuildingBroker?: IBrokerData;
}

export interface INewbuildingPromoSnippet {
  extensionFields: INewbuildingPromoSnippetExtensionFields;
  newbuilding: INewbuilding;
}

export interface IDynamicCalltracking {
  siteBlockId?: number | null;
}

export interface INewbuildingPromoSnippetPhone {
  code: string;
  countryCode: string;
  number: string;
}

export interface INewbuildingPromoSnippetBuilders {
  newbuildingDynamicCalltracking: IDynamicCalltracking;
  phone: INewbuildingPromoSnippetPhone;
  realtyUserId: number;
  showPhone: boolean;
}

export interface INewbuildingPromoSnippetSellers {
  newbuildingDynamicCalltracking: IDynamicCalltracking;
  phone: INewbuildingPromoSnippetPhone;
  realtyUserId: number;
  showPhone?: boolean | null;
}

export interface INewbuildingPromoSnippetImage {
  fullUrl: string;
  isDefault: boolean;
}

export interface INewbuildingPromoSnippetExtensionFields {
  builders: INewbuildingPromoSnippetBuilders[];
  images: INewbuildingPromoSnippetImage[];
  sellers: INewbuildingPromoSnippetSellers[];
}
